// Commercial details verified against the checkout and the published business policies.
export const offer = {
  packageName: "BAGMAKING READY — Volume 01 Bundle",
  summary: "1 sewing manual + 5 digital bonuses",
  includes: [
    "40-page digital sewing manual in English",
    "10 bag and accessory projects",
    "Material lists and rectangular cutting plans",
    "Dimensions in inches and metric",
    "Labeled diagrams and illustrated sewing steps",
    "All 5 complementary digital bonuses",
  ],
  price: "$27" as string | null,
  compareAtPrice: null as string | null, // only if a real previous price exists
  currency: "USD" as string | null,
  paymentTerms: "One-time payment" as string | null,
  checkoutUrl: "https://bagmaking-ready.impultienda.ar/checkout" as string | null,
  delivery: "Sent to your email" as string | null,
  accessDuration: "Lifetime access" as string | null,
  paymentMethods: ["Credit and debit cards via Stripe"] as string[],
  guarantee: {
    title: "10-day guarantee",
    terms: [
      "You may request a refund within 10 days of purchase, subject to our published refund policy.",
      "Refunds apply if you have downloaded no more than 50% of the content.",
      "Email support@stockdigital.shop from the address used at checkout and include your order number.",
    ],
  } as { title: string; terms: string[] } | null,
};

export const brand = {
  name: "BAGMAKING READY",
  tagline: "Everyday projects. Clearly planned.",
  contactEmail: "support@stockdigital.shop" as string | null,
  legalName: "infinity vantora LLC",
  refundPolicyUrl: "https://www.stockdigital.shop/refund-policy?lang=en",
  socials: [] as { label: string; url: string }[],
  legalLinks: [
    { label: "Privacy Policy", url: "https://www.stockdigital.shop/privacy?lang=en" },
    { label: "Terms & Conditions", url: "https://www.stockdigital.shop/terms?lang=en" },
    { label: "Refund & Delivery Policy", url: "https://www.stockdigital.shop/refund-policy?lang=en" },
  ] as { label: string; url: string }[],
};
